<template>

    <div ref="mainHigh" class="mianLogin">
        <div class="backTop">
            <LeftOutlined class="fl" @click="goBack()"/>
        </div>
        <div v-if="formShow">
            <div v-for="(item,key) in form" :key="key" class="input-groud" @click="goMore('/webHighEnterpriseEvaluation/detail',item.evaluateFlag, item.optionScore)">
                <h4>测评结果：（{{item.optionScore}}分） {{item.scoreEvaluation}}</h4>
                <div><span>自测</span> {{item.evaluateTime}}</div>
            </div>
            <a-empty v-if="form.length===0"/>
        </div>
    </div>
  </template>

  <script>
  import { basicsEvaluateResult } from "@/api/webHighEnterpriseEvaluation";
  import {ls} from "@/utils/util";
  import axios from "axios";
  import {notification} from "ant-design-vue";
  import {encryptByRSA} from "@/utils/encryption/jsencrypt-rsa";
  export default {
    data () {
        return {
            formShow:false
        }
    },
    mounted() {
      // this.$refs.mainHigh.style.height = window.innerHeight+'px'
    this.getPageList()

    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        // 结果列表
        getPageList() {
            /*this.getAction({
                url: basicsEvaluateResult.list,
                params:{
                    user:ls.get('wxLoginPhone'),
                }
            }
            ).then((res) => {
                if(res){
                    this.form = res
                    this.formShow =true
                }
            })*/
        var phone = encryptByRSA(ls.get('wxLoginPhone'));
          this.getAxios('get', basicsEvaluateResult.list, {
            user: phone,
          }, (res) => {
            if(res){
              this.form = res.data.data
              this.formShow =true
            }
          })
        },
      getAxios(method, url, params, fun) {
        axios({
          method: method,
          headers: {
            AuthenticationPhone: ls.get('jwtphone'),
            AuthenticationJwt: ls.get('jwtMain')
          },
          url: url,
          params: params
        }).then(res => {
          if (res) {
            fun(res)
          }
        }).catch(() => {
          this.visible = false
          notification.warning({
            message: '登录过期',
            style: {
              width: '400px',
              fontWeight: '600',
              marginLeft: `${-200}%`,
              marginTop: `${20}%`,
            }
          });
          this.modalShowType = null
          setTimeout(() => {
            this.visible = true
          }, 50);
        })
      },
        //路由跳转
        goMore(url, str, score) {
          // alert(str)
            if(str){
                this.$router.push({ path: url, query: { flag: str, score:score } })
            }else{
                this.$router.push({ path: url, query: { score:score } })
            }
        },
    }
  };
  </script>
  <style lang="less" scoped>
  .mianLogin{
    font-family: '微软雅黑';
    width:100%;
    background: #f1f1f1;
    display: flex;
    flex-direction: column;
    padding:.5rem 0;
    align-items: center;
    .backTop{
        width:100%;
        text-align: center;
        height:2rem;
        padding-top: .2rem;
        font-size: 1.1rem;
        .fl{
            float: left;
            margin:.3rem 0 0 1rem;
        }
    }
    .input-groud{
        margin:.5rem 0;
        display: flex;
        flex-direction: column;
        width:95vw;
        padding:1.1rem 1.1rem;
        background: #fff;
        position: relative;
        border-radius: .4rem;
        font-size: .6rem;
        h4{
            font-size: 1rem;
            margin-bottom:.8rem;
        }
        span{
            background: #d4feff;
            padding:0 .2rem;
            color: rgb(0, 119, 255);
        }
    }
  }
  </style>
